
var sprintf = (str, args) => {
    if(args.length > 0){
    args.reverse();
    while(args.length > 0){
        var arg = args.pop();
        str = str.replace("%s",arg);
    }
}
    return str;
}

var translator = {
    translate: (key, def, args) => {
        if(!window.pixelpoint.translations || !window.pixelpoint.translations[key] || typeof window.pixelpoint.translations[key] !== "string"){
            return !!args ? sprintf(def, args) : def;
        }
        var translation = window.pixelpoint.translations[key];
        return !!args ? sprintf(translation, args) : translation;
    }
}
window.ppt = translator;